export default __webpack_public_path__ + "static/media/debris_of_decarabians_city.c6a58e2f.png";